import React, { createContext, useState, useContext, useEffect } from 'react';
import { endSession } from 'helpers/session';

const AuthContext = createContext();

export default function AuthProvider({ children }) {
    const [isAuth, setIsAuth] = useState(!!localStorage.getItem('token'));
    const [token, setToken] = useState(localStorage.getItem('token'));

    useEffect(() => {
        // Listen for auth token removal from interceptor
        const handleAuthRemoved = () => {
            setIsAuth(false);
            setToken(null);
        };

        window.addEventListener('auth-token-removed', handleAuthRemoved);

        return () => {
            window.removeEventListener('auth-token-removed', handleAuthRemoved);
        };
    }, []);

    const login = (newToken) => {
        localStorage.setItem('token', newToken);
        setToken(newToken);
        setIsAuth(true);
    };

    const logout = () => {
        endSession();
        setToken(null);
        setIsAuth(false);
    };

    const user = isAuth && localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user'))
        : null;

    return (
        <AuthContext.Provider value={{
            isAuth,
            token,
            user,
            login,
            logout,
            toggleAuth: setIsAuth // Backward compatibility
        }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}
